import React, { useCallback, useMemo, useState } from 'react';
import TranslateConversationItem from 'scripts/application/actions/conversation_item/translate_conversation_item';
import useExecuteAction from 'components/hooks/use_execute_action';

const ItemContext = React.createContext({
  itemId: null,
});
export default ItemContext;

export function ItemContextProvider({ children, item }) {
  const [isViewTranslation, setViewTranslation] = useState(true);
  const toggleViewTranslation = () => {
    setViewTranslation(!isViewTranslation);
  };

  const [isTranslating, setIsTranslating] = useState(false);
  const executeAction = useExecuteAction();
  const handleTranslate = useCallback(
    targetLanguage => {
      setIsTranslating(true);
      setViewTranslation(true);

      executeAction(TranslateConversationItem, {
        conversationItem: item,
        customerId: item.customerId,
        targetLanguage,
        onComplete: () => {
          setIsTranslating(false);
        },
      });
    },
    [item, executeAction]
  );

  const value = useMemo(
    () => ({
      item,
      isViewTranslation,
      toggleViewTranslation,
      isTranslating,
      setIsTranslating,
      handleTranslate,
    }),
    [item, isTranslating, setIsTranslating, handleTranslate, isViewTranslation, toggleViewTranslation]
  );

  return <ItemContext.Provider value={value}>{children}</ItemContext.Provider>;
}
